/**
 * Created by Ning Jiang on 2/22/2018.
 */

import {EventHandler} from "@nolimitcity/slot-game/bin/core/event/EventHandler";
import {GameEvent} from "@nolimitcity/slot-game/bin/core/event/GameEvent";
import {GameConfig} from "@nolimitcity/slot-game/bin/core/gameconfig/GameConfig";
import {GameModeEvent} from "@nolimitcity/slot-game/bin/core/gamemode/event/GameModeEvent";
import {Reels} from "@nolimitcity/slot-game/bin/core/reel/reelarea/Reels";
import {IScreenConfig} from "@nolimitcity/slot-game/bin/core/screen/ScreenController";
import {ParsedServerData} from "@nolimitcity/slot-game/bin/core/server/data/ParsedServerData";
import {SlotGame} from "@nolimitcity/slot-game/bin/core/SlotGame";
import {FreespinIntroController} from "@nolimitcity/slot-game/bin/game/screen/freespinintro/FreespinIntroController";
import {TimelineLite} from "gsap";
import {FreespinsLeftIndicator} from "../../freespinsleft/FreespinsLeftIndicator";
import {SymbolBurstAnimator} from "../../reelsymbol/SymbolBurstAnimator";
import {WildNudgeReelSymbol} from "../../reelsymbol/WildNudgeReelSymbol";
import {WildNudgeGameConfig} from "../../WildNudgeGameConfig";
import {WildNudgeSoundConfig} from "../../WildNudgeSoundConfig";

export class WildNudgeFreespinIntroController extends FreespinIntroController {

    private _scatterPositions:number[];

    constructor(config:IScreenConfig) {
        super(config);
    }

    protected parseFeatureGameData(data:ParsedServerData):void {
        this._scatterPositions = data.scatterPositions!;
    }

    protected doTransitions():void {
        if(!this.shouldShow()) {
            this.playFSLoop();
            return;
        }

        const timeline:TimelineLite = new TimelineLite({paused : true});
        timeline.add(() => EventHandler.dispatchEvent(new GameEvent(GameModeEvent.CHANGE_MODE, {newMode : this._serverData!.nextMode})));
        for(let reelId:number = 0; reelId < GameConfig.instance.REELS_NUM; reelId++) {
            for(let symbolId:number = 0; symbolId < GameConfig.instance.SYMBOLS_NUM_IN_REEL[2]; symbolId++) {
                const symbol:WildNudgeReelSymbol | null = <WildNudgeReelSymbol>Reels.getSymbol(reelId, symbolId);
                if(!symbol) {
                    debugger;
                    throw new Error(`WildNudgeFreespinIntroController.doTransitions():Cannot find symbol at reel${reelId} symbol${symbolId}!`);
                }

                if(symbolId === this._scatterPositions[reelId]) {
                    timeline.add(symbol.changeState({
                        state : WildNudgeGameConfig.instance.SYMBOL_STATES.win,
                        replay : false,
                        fadeInDuration : 0.1
                    }), 0);
                    timeline.add(SymbolBurstAnimator.playIdleFireWin(reelId, this._scatterPositions[reelId]), 0);
                } else {
                    // dim no scatter symbols.
                    timeline.add(() => symbol.dim(0, true), 0);
                }
            }
        }
        timeline.add(() => this.playFSLoop(), 2.281);

        timeline.play();
    }

    private playFSLoop():void {
        SlotGame.sound.fadeAmbience(0, 0);
        SlotGame.sound.playAmbience(WildNudgeSoundConfig.instance.FREE_SPIN_AMBIANCE);
        SlotGame.sound.fadeAmbience(1, 0);
    }

    protected onCloseComplete():void {
        if(this.shouldShow()) {
            // undim symbols
            for(let reelId:number = 0; reelId < GameConfig.instance.REELS_NUM; reelId++) {
                for(let symbolId:number = 0; symbolId < GameConfig.instance.SYMBOLS_NUM_IN_REEL[2]; symbolId++) {
                    const symbol:WildNudgeReelSymbol | null = <WildNudgeReelSymbol>Reels.getSymbol(reelId, symbolId);
                    if(!symbol) {
                        debugger;
                        throw new Error(`WildNudgeFreespinIntroController.onCloseComplete():Cannot find symbol at reel${reelId} symbol${symbolId}!`);
                    }
                    symbol.changeState({
                        state : WildNudgeGameConfig.instance.SYMBOL_STATES.normal,
                        fadeInDuration : 0
                    });
                    if(symbolId !== this._scatterPositions[reelId]) {
                        symbol.undim(0, true);
                    }
                }
            }
        }

        EventHandler.dispatchEvent(new GameEvent(FreespinsLeftIndicator.ACTIVATE_INDICATOR));

        // This will turn off Autoplay if in restricted jurisdiction
        if(SlotGame.autoPlay.turnOffAutoplayOnBonus) {
            SlotGame.autoPlay.turnOffAutoplayOnBonus();
        }

        super.onCloseComplete();
    }
}